import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { ListsProvider } from "@/contexts/ListsContext";
import { MessagesProvider } from "@/contexts/MessagesContext";
import MessagesDrawer from "@/components/MessagesDrawer";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import ListPage from "@/pages/ListPage";
import ProfilePage from "@/pages/ProfilePage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import HallOfFamePage from "@/pages/HallOfFamePage";
import CollectionPage from "@/pages/CollectionPage";
import SettingsPage from "@/pages/SettingsPage";
import ChatPage from "@/pages/ChatPage";
import SoftwarePage from "@/pages/SoftwarePage";
import RulesPage from "@/pages/RulesPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import FriendsPage from "@/pages/FriendsPage";
import MessagesPage from "@/pages/MessagesPage";
import ForumsPage from "@/pages/ForumsPage";
import ForumPage from "@/pages/ForumPage";
import ThreadPage from "@/pages/ThreadPage";
import LinkDevicePage from "@/pages/LinkDevicePage";
import DownloadsPage from "@/pages/DownloadsPage";
import DonateSuccessPage from "@/pages/DonateSuccessPage";
import useVisitPing from "@/hooks/useVisitPing";

function Router() {
  const location = useLocation();
  useVisitPing();
  // Detect Emergent OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/title/:mediaType/:tmdbId" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/watchlist" element={<ListPage type="watchlist" />} />
      <Route path="/favorites" element={<ListPage type="favorites" />} />
      <Route path="/u/:userId" element={<ProfilePage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/hall-of-fame" element={<HallOfFamePage />} />
      <Route path="/collection/:collectionId" element={<CollectionPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/software" element={<SoftwarePage />} />
      <Route path="/rules" element={<RulesPage />} />
      <Route path="/disclaimer" element={<DisclaimerPage />} />
      <Route path="/friends" element={<FriendsPage />} />
      <Route path="/messages" element={<MessagesPage />} />
      <Route path="/forums" element={<ForumsPage />} />
      <Route path="/forums/:slug" element={<ForumPage />} />
      <Route path="/forums/:slug/:threadId" element={<ThreadPage />} />
      <Route path="/link" element={<LinkDevicePage />} />
      <Route path="/downloads" element={<DownloadsPage />} />
      <Route path="/donate/success" element={<DonateSuccessPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ListsProvider>
            <MessagesProvider>
              <Router />
              <MessagesDrawer />
              <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                  style: {
                    background: "#121212",
                    border: "1px solid #2a2a2a",
                    color: "#fff",
                  },
                }}
              />
            </MessagesProvider>
          </ListsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
